export default "__VITE_ASSET__DaUM5LKg__"